<template>
	<div class="banners">
		<swiper :options='swiperOption' v-if="pics.length>0">
			<swiper-slide v-for="(item,index) in pics" :key="index" class="bannerDiv">
				<img :src="item.fromUrl+item.name" />
			</swiper-slide>
			<div class='swiper-pagination' slot='pagination'></div>
		</swiper>
	</div>
</template>

<script>
	import 'swiper/dist/css/swiper.css'
	import {swiper,swiperSlide} from 'vue-awesome-swiper'
	export default {
		props: {
			pics: {
				required: true,
				type: Array
			}
		},
		components: {
			swiper,
			swiperSlide
		},
		data() {
			return {
				swiperOption: {
					speed:3000,
					loop:true,
					slidesPerView:1, //设置显示容器同时显示的数量					
					initialSlide:1, //初始化首页的索引。
					autoplay:{
						delay:3000, //自动切换时间。
						disableOnInteraction:false //操作swiper后,不停止切换
					},					
					paginationClickable:true,					
					spaceBetween:30,					
					pagination: {
					    el: '.swiper-pagination',
						clickable :true
					},
				}
			}
		},
	}
</script>

<style scoped>
	.banners {
		width: 1300px;
		margin: auto;
	}

	.bannerDiv {
		width: 100%;
		height: 285px;
	}

	.bannerDiv img {
		width: 100%;
		height: 100%;
		border-radius: 5px;
	}
</style>
